
/*******************
 * Landscape video
 *******************/

const videosL = document.querySelectorAll(".video-wrap video");
const playButtonsL = document.querySelectorAll(".video-wrap .icon-play");
const posterImagesL = document.querySelectorAll(".video-wrap img");

// Function to handle the play event for each video
function playVideo(currentVideo, playButton, posterImage) {
	// Pause all other videos
	videosL.forEach((video, index) => {
		if (video !== currentVideo) {
			video.pause();
			video.controls = false;
			playButtonsL[index].style.display = "flex";
			posterImagesL[index].style.display = "block";
			video.style.display = "none";
		}
	});

	currentVideo.play();
	currentVideo.controls = true;
	playButton.style.display = "none";
	if(typeof(posterImage) != 'undefined') {
		posterImage.style.display = "none";
	}
	currentVideo.style.display = "block";

	currentVideo.addEventListener("click", preventPause);
	currentVideo.addEventListener("seeking", function (event) {
		if (currentVideo.paused) {
			currentVideo.play();
		}
	});

	currentVideo.addEventListener("pause", function () {
		currentVideo.controls = false;
		playButton.style.display = "flex";
		if(typeof(posterImage) != 'undefined') {
			posterImage.style.display = "block";
		}
		document.querySelectorAll(".vplay").style.display = "block";

		currentVideo.style.display = "none";
	});

	currentVideo.addEventListener("play", function () {
		playButton.style.display = "none";
		if(typeof(posterImage) != 'undefined') {
			posterImage.style.display = "none";
		}
		// if(typeof(currentVideo) != 'undefined') {
			currentVideo.controls = true;
			currentVideo.style.display = "block";
		// }
	});
	}

	// Prevent pause event function
	function preventPause(event) {
		event.preventDefault();
		event.stopPropagation();
	}

	// Loop through each video element and assign event listeners
	videosL.forEach((video, index) => {
	const playButton = playButtonsL[index];
	const posterImage = posterImagesL[index];

	if (playButton) {
		playButton.addEventListener("click", function () {
			playVideo(video, playButton, posterImage);
		});
	}
});